<template>
  <div
    class="vue-query-builder"
    :class="{ 'vue-query-builder-styled': styled }"
  >
    <layer-query-builder-group
      :index="0"
      :query.sync="query"
      :ruleTypes="ruleTypes"
      :rules="mergedRules"
      :maxDepth="maxDepth"
      :depth="depth"
      :styled="styled"
      :labels="mergedLabels"
      type="layer-query-builder-group"
    ></layer-query-builder-group>
  </div>
</template>

<script>
import LayerQueryBuilderGroup from "@/pages/MapPage/Tools/Layers/LayerQueryBuilderGroup.vue";
import deepClone from "./utilities.js";
let defaultLabels = {
  matchType: "Logisk operator",
  matchTypes: [{ id: "all", label: "OG" }, { id: "any", label: "ELLER" }],
  addRule: "+ Regel",
  removeRule: "&times;",
  addGroup: "+ Gruppe",
  removeGroup: "&times;",
  textInputPlaceholder: "Verdi"
};
export default {
  name: "layer-query-builder",
  components: {
    LayerQueryBuilderGroup
  },
  props: {
    rules: Array,
    labels: {
      type: Object,
      default() {
        return defaultLabels;
      }
    },
    styled: {
      type: Boolean,
      default: true
    },
    maxDepth: {
      type: Number,
      default: 3,
      validator: function(value) {
        return value >= 1;
      }
    },
    value: Object
  },
  data() {
    return {
      depth: 1,
      query: {
        logicalOperator: this.labels.matchTypes[0].id,
        children: []
      },
      ruleTypes: {
        text: {
          operators: [
            "er lik",
            "er ikke lik",
            "inneholder",
            "inneholder ikke",
            "finnes i",
            "finnes ikke i",
            "begynner med",
            "slutter med",
            "er tom",
            "er ikke tom",
            "er null",
            "er ikke null"
          ],
          inputType: "text",
          id: "text-field"
        },
        numeric: {
          operators: [
            "er lik (numerisk)",
            "er ikke lik (numerisk)",
            "er mindre enn",
            "er mindre enn eller lik",
            "er større enn",
            "er større enn eller lik"
          ],
          inputType: "number",
          id: "number-field"
        },
        custom: {
          operators: [],
          inputType: "text",
          id: "custom-field"
        },
        radio: {
          operators: [],
          choices: [],
          inputType: "radio",
          id: "radio-field"
        },
        checkbox: {
          operators: [],
          choices: [],
          inputType: "checkbox",
          id: "checkbox-field"
        },
        select: {
          operators: [
            "er lik",
            "er ikke lik",
            "inneholder",
            "inneholder ikke",
            "finnes i",
            "finnes ikke i",
            "begynner med",
            "slutter med",
            "er tom",
            "er ikke tom",
            "er null",
            "er ikke null"
          ],
          choices: [],
          inputType: "select",
          id: "select-field"
        },
        selectNumeric: {
          operators: ["er lik (numerisk)", "er ikke lik (numerisk)"],
          choices: [],
          inputType: "selectNumeric",
          id: "select-field"
        },
        boolean: {
          operators: ["er lik", "er ikke lik", "er tom", "er ikke tom"],
          choices: [],
          inputType: "select",
          id: "select-field"
        },
        "multi-select": {
          operators: ["="],
          choices: [],
          inputType: "select",
          id: "multi-select-field"
        }
      }
    };
  },
  computed: {
    mergedLabels() {
      return Object.assign({}, defaultLabels, this.labels);
    },
    mergedRules() {
      let mergedRules = [];
      let vm = this;

      vm.rules.forEach(function(rule) {
        if (typeof vm.ruleTypes[rule.type] !== "undefined") {
          mergedRules.push(Object.assign({}, vm.ruleTypes[rule.type], rule));
        } else {
          mergedRules.push(rule);
        }
      });

      mergedRules = mergedRules.sort(this.sortRules);
      return mergedRules;
    }
  },
  methods: {
    sortRules: function(a, b) {
      let nameA = a.label.toUpperCase();
      let nameB = b.label.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      return 0;
    }
  },
  mounted() {
    this.$watch(
      "query",
      newQuery => {
        if (JSON.stringify(newQuery) !== JSON.stringify(this.value)) {
          this.$emit("input", deepClone(newQuery));
        }
      },
      {
        deep: true
      }
    );
    this.$watch(
      "value",
      newValue => {
        if (JSON.stringify(newValue) !== JSON.stringify(this.query)) {
          this.query = deepClone(newValue);
        }
      },
      {
        deep: true
      }
    );
    if (typeof this.$options.propsData.value !== "undefined") {
      this.query = Object.assign(this.query, this.$options.propsData.value);
    }
  }
};
</script>

<style>
.vue-query-builder-styled .vqb-group .rule-actions {
  margin-bottom: 20px;
}
.vue-query-builder-styled .vqb-rule {
  margin-top: 15px;
  margin-bottom: 15px;
  background-color: #f5f5f5;
  border-color: #ddd;
  padding: 15px;
}
.vue-query-builder-styled .vqb-rule label {
  margin-right: 10px;
}
.vue-query-builder-styled .vqb-group.depth-1 .vqb-rule,
.vue-query-builder-styled .vqb-group.depth-2 {
  border-left: 2px solid #8bc34a;
}
.vue-query-builder-styled .vqb-group.depth-2 .vqb-rule,
.vue-query-builder-styled .vqb-group.depth-3 {
  border-left: 2px solid #00bcd4;
}
.vue-query-builder-styled .vqb-group.depth-3 .vqb-rule,
.vue-query-builder-styled .vqb-group.depth-4 {
  border-left: 2px solid #ff5722;
}
.vue-query-builder-styled .close {
  opacity: 1;
  color: rgb(150, 150, 150);
}
@media (min-width: 768px) {
  .vue-query-builder-styled .vqb-rule.form-inline .form-group {
    display: block;
  }
}
</style>
